import { getPageText } from '../api';
import camelize from 'camelcase-keys-deep';

import { PAGE_TEXT_FETCHING, PAGE_TEXT_FETCHED } from './';

export default function fetchPageText() {
  return async dispatch => {
    dispatch({ type: PAGE_TEXT_FETCHING });

    return getPageText().then(pageText => {
      return dispatch({
        type: PAGE_TEXT_FETCHED,
        pageText: camelize(pageText),
      });
    });
  };
}
